<template>
  <div class="title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'title',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // eslint-disable-next-line vue/no-dupe-keys
      value: true
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  color: $primary-dark-blue;
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 40px;
  &::after {
    content: '';
    width: 100px;
    height: 4px;
    display: block;
    margin: 0 auto;
    margin-top: 16px;
    background: $primary-blue;
  }
}
@media (max-width: 768px) {
  .title {
    font-size: 18px;
    margin-bottom: 24px;
    &::after {
      width: 26px;
      height: 2px;
      margin-top: 6px;
    }
  }
}
</style>
